import { render, staticRenderFns } from "./StatsTeamGrowth.vue?vue&type=template&id=3f28b5f4&scoped=true&lang=html&"
import script from "./StatsTeamGrowth.vue?vue&type=script&lang=js&"
export * from "./StatsTeamGrowth.vue?vue&type=script&lang=js&"
import style0 from "./StatsTeamGrowth.vue?vue&type=style&index=0&id=3f28b5f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28b5f4",
  null
  
)

export default component.exports